import urls from '@tuic/lib/urls';
import { EventClickElement } from '@tuic/tracking';
import Image from 'next/image';

import TuiCruisesLogo from '../../../../../ui-kit/assets/logos/tui-cruises.svg';

import type { Locale } from '@tuic/i18n';

type Props = { locale?: Locale };

/**
 * Renders the footer logo.
 */
const FooterLogo = ({ locale }: Props) => {
  return (
    <a
      className="ml-auto mt-[0.9375rem] block w-[5.625rem] sm:w-[8.75rem] lg:order-2 lg:my-0 lg:ml-auto lg:mr-0 lg:w-[13.75rem]"
      href={urls.mainLocalized.home(locale ?? 'de')}
    >
      <Image
        data-track-click-element={EventClickElement.Logo}
        data-track-click-label="TUI Cruises"
        src={TuiCruisesLogo}
        width={220}
        height={54}
        alt="TUI Cruises"
      />
    </a>
  );
};

export default FooterLogo;
